class productStickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.mainButton = document.querySelector("[data-track-add-to-cart-main]");
    // this.showBar();
    this.scopeFromPassed = false;
    this.scopeToReached = false;
    this.intersectionObserver = new IntersectionObserver(this._onObserved.bind(this));

  }

  connectedCallback() {
    this._scopeFrom = document.getElementById(this.getAttribute("form"));
    this._scopeTo = document.querySelector(".footer");
    if (!this._scopeFrom || !this._scopeTo) {
      return;
    }
    this.intersectionObserver.observe(this._scopeFrom);
    this.intersectionObserver.observe(this._scopeTo);
  }
  disconnectedCallback() {
    this.intersectionObserver.disconnect();
  }
  _onObserved(entries) {
    entries.forEach((entry) => {
      if (entry.target === this._scopeFrom) {
        this.scopeFromPassed = entry.boundingClientRect.bottom < 0;
      }
      if (entry.target === this._scopeTo) {
        this.scopeToReached = entry.isIntersecting;
      }
    });
  
    const formAboveViewport = this._scopeFrom.getBoundingClientRect().top > window.innerHeight;
    const formBelowViewport = this._scopeFrom.getBoundingClientRect().bottom < 0;
  
    const showQuickAdd = (formAboveViewport || formBelowViewport) && !this.scopeToReached;
    this.classList.toggle("is-visible", showQuickAdd);
    document.body.classList.toggle("sticky-add-to-cart-enable", showQuickAdd);
  }


  showBar() {
    this.classList.add("product__sticky-atc--visible");
  }

  hideBar() {
    this.classList.remove("product__sticky-atc--visible");
  }
}

if (!customElements.get("sticky-add-to-cart")) {
  customElements.define("sticky-add-to-cart", productStickyAddToCart);
}
